import React from "react";
import {
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Stack,
    Typography,
    InboxFilledIcon,
    DraftsFilledIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicListWithIcon = () => {
    return (
        <Stack spacing={2} p={3}>
            <Box>
                <Typography variant={"h6"} color={"text.primary"}>
                   List Item with Start Icon
                </Typography>
            </Box>
            <Box sx={{ width: "80%", alignSelf: "center" }}>
                <PreviewAndEditor
                    language="js"
                    title={"Dense List with icon"}
                    background
                    value={"                <List dense>\n" +
                        "                        <ListItem disablePadding>\n" +
                        "                            <ListItemButton>\n" +
                        "                                <ListItemIcon>\n" +
                        "                                    <InboxIcon />\n" +
                        "                                </ListItemIcon>\n" +
                        "                                <ListItemText primary=\"Inbox\" />\n" +
                        "                            </ListItemButton>\n" +
                        "                        </ListItem>\n" +
                        "                        <ListItem disablePadding>\n" +
                        "                            <ListItemButton>\n" +
                        "                                <ListItemIcon>\n" +
                        "                                    <DraftsIcon />\n" +
                        "                                </ListItemIcon>\n" +
                        "                                <ListItemText primary=\"Drafts\" />\n" +
                        "                            </ListItemButton>\n" +
                        "                        </ListItem>\n" +
                        "                    </List>"}
                >
                    <Paper p={3} elevation={0} sx={{width: 250}}>
                    <List dense>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <InboxFilledIcon />
                                </ListItemIcon>
                                <ListItemText primary="Inbox" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <DraftsFilledIcon />
                                </ListItemIcon>
                                <ListItemText primary="Drafts" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                    </Paper>
                </PreviewAndEditor>
            </Box>
        </Stack>
    );
};

export default BasicListWithIcon;
